module.exports = __webpack_public_path__ + "img/Image2.cfc4a0c8.png";